import { createAction, props } from '@ngrx/store';
import { TokenUser } from '@shared';

export const loadCurrentUser = createAction('[Current User] Load Current User');
export const loadCurrentUserSuccess = createAction(
  '[Current User] Load currentUser Success',
  props<{ currentUser: TokenUser }>(),
);
